
import { useState } from 'react';

interface ForumHeaderProps {
  onCreateTopic: () => void;
}

export default function ForumHeader({ onCreateTopic }: ForumHeaderProps) {
  const [searchQuery, setSearchQuery] = useState('');

  return (
    <div className="bg-white shadow-sm border-b border-green-100">
      <div className="max-w-7xl mx-auto px-4 py-6">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          {/* Logo and Title */}
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 bg-gradient-to-br from-green-500 to-emerald-600 rounded-xl flex items-center justify-center">
              <i className="ri-discuss-line text-white text-xl"></i>
            </div>
            <div>
              <h1 className="text-2xl font-bold text-gray-900" style={{ fontFamily: '"Pacifico", serif' }}>
                Salad Forum
              </h1>
              <p className="text-sm text-gray-600">Connect, discuss, and discover together</p>
            </div>
          </div>

          {/* Search and Actions */}
          <div className="flex items-center gap-4">
            <div className="relative">
              <input
                type="text"
                placeholder="Search discussions..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-64 pl-10 pr-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm"
              />
              <i className="ri-search-line absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm"></i>
            </div>
            
            <button
              onClick={onCreateTopic}
              className="bg-gradient-to-r from-green-500 to-emerald-600 text-white px-6 py-2 rounded-lg hover:from-green-600 hover:to-emerald-700 transition-all duration-200 font-medium text-sm whitespace-nowrap cursor-pointer flex items-center gap-2"
            >
              <i className="ri-add-line text-sm"></i>
              New Topic
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
